export default __webpack_public_path__ + "static/media/Tachyons.ea96b4e1.png";